import { MAX_POPUP_ABOVE_LEN } from '../utils/constants';
import { DirectionalHint } from 'office-ui-fabric-react/lib/Callout';

export default function getDirectionalHint(selection: string): DirectionalHint {
    return selection.length < MAX_POPUP_ABOVE_LEN
        ? DirectionalHint.topCenter
        : DirectionalHint.bottomCenter;
}
